import {stripEmojis, stripHTML} from "../libs/stripHTML";

declare global {
    interface Window {
        AudioContext: any;
        webkitAudioContext: any;
    }
}

import {createContext} from "preact";
import {createScript} from "../libs/ScriptHelper";
import {log} from "../libs/QuerloLogger";

declare const SpeechSDK: any;

export enum VoiceContextEvents  {
  PLAYBACK_STARTED,
  PLAYBACK_STOPPED,
  SYNTHESIZER_VISEME_RECEIVED
}

export class VoiceContextImpl {
    // https://github.com/Azure-Samples/cognitive-services-speech-sdk/blob/master/samples/js/browser/synthesis.html

    private speechConfig: any;
    private synthesizer: any;
    private audioInstance: HTMLAudioElement | null = null;
    private voiceMetaData: {active: boolean; style: string; voice_type: string; region: string};
    private assetsBaseURL = '';
    private backendBaseURL = '';
    private token = '';
    private soundBeep = "data:audio/wav;base64,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";

    private speechRecognizer: any = null;

    private eventListeners: Record<VoiceContextEvents, ((e: any) => void)[]> = {[VoiceContextEvents.PLAYBACK_STARTED]: [],[VoiceContextEvents.PLAYBACK_STOPPED]: [], [VoiceContextEvents.SYNTHESIZER_VISEME_RECEIVED]: []};


    constructor(config: any, assetsBaseURL: string, backendBaseURL: string) {
        this.assetsBaseURL = assetsBaseURL;
        this.backendBaseURL = backendBaseURL;
        this.voiceMetaData = config;
        this.audioInstance = new Audio();

        if (!config.region) {
            config.region = 'francecentral';
        }
    }

    public initAzureSpeechSDK(): Promise<void> {
        if (!this.token) {
            return createScript(`${this.assetsBaseURL}js/vendor/microsoft.cognitiveservices.speech.sdk.bundle-min.js`).then(() => {
                return fetch(`${this.backendBaseURL}voice/token`,
                  {
                      method: 'POST',
                      mode: 'cors',
                      credentials: 'same-origin',
                      // eslint-disable-next-line @typescript-eslint/camelcase
                      body: JSON.stringify({t: 1}),
                      headers: {'Content-Type': 'application/json'}
                  })
                  .then((r: any) => {
                    return r.json().then((responseObj: any) => {
                        this.token = responseObj.token;
                        // log.info("token successfully retrieved ", responseObj.token);
                    });
                });
            });
        }
        return Promise.resolve();
    }
    
    public initSpeakOut(): Promise<void> {
      return this.beep().then(() => {
        return this.initAzureSpeechSDK().then(() => {
          this.speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(
            this.token,
            this.voiceMetaData.region
          );
          this.speechConfig.speechSynthesisVoiceName =
            this.voiceMetaData.voice_type;
          this.synthesizer = new SpeechSDK.SpeechSynthesizer(
            this.speechConfig,
            null
          );

          // Subscribes to viseme received event
          this.synthesizer.visemeReceived = (s: any, e: any) => {
            this.dispatchVoiceEvent(
              VoiceContextEvents.SYNTHESIZER_VISEME_RECEIVED,
              e
            );
            log.trace(
              `((_VOICE_)) (Viseme), Audio offset: ${
                e.audioOffset / 10000
              }MS Viseme ID: ${e.visemeId}`
            );
          };
          log.debug("((_VOICE_)) Voice OUT initialization completed");
        });
      });
    }

  private onRecognizing = (sender: any, recognitionEventArgs: any): void => {
    const result = recognitionEventArgs.result;
    let status = `(recognizing) Reason: ${SpeechSDK.ResultReason[result.reason]}`
      + ` Text: ${result.text}\r\n`;
    // Update the hypothesis line in the phrase/result view (only have one)
    status = status.replace(/(.*)(^|[\r\n]+).*\[\.\.\.\][\r\n]+/, '$1$2')
      + `${result.text} [...]\r\n`;
    log.info(status);
  }

  private onRecognizedResult = (result: any, resolve: any): void => {
    log.debug(`((_VOICE_)) (recognized)  Reason: ${SpeechSDK.ResultReason[result.reason]}`);
    let details: any;

    switch (result.reason) {
      case SpeechSDK.ResultReason.NoMatch:
       details = SpeechSDK.NoMatchDetails.fromResult(result);
        log.debug(`((_VOICE_))  NoMatchReason: ${SpeechSDK.NoMatchReason[details.reason]}`);
        break;
      case SpeechSDK.ResultReason.Canceled:
        details = SpeechSDK.CancellationDetails.fromResult(result);
        log.debug(`((_VOICE_))  CancellationReason: ${SpeechSDK.CancellationReason[details.reason]}`);
        break;
      case SpeechSDK.ResultReason.RecognizedSpeech:
      case SpeechSDK.ResultReason.TranslatedSpeech:
      case SpeechSDK.ResultReason.RecognizedIntent:
        log.debug(`((_VOICE_)) ${result.text}`);
        break;
    }

    if (resolve) resolve(result.privText);
  }

  private onRecognized = (sender: any, recognitionEventArgs: any): void => {
    this.onRecognizedResult(recognitionEventArgs.result, null);
  }

    private initSpeakIn(): Promise<void> {
      return this.initAzureSpeechSDK().then(() => {
        if (this.speechRecognizer === null) {

           const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
           const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(this.token, this.voiceMetaData.region);

              if (SpeechSDK.SpeechConfig !== SpeechSDK.SpeechConfig) {
                log.debug('((_VOICE_)) Detailed results are not supported for this scenario.');
              } else {
                speechConfig.outputFormat = SpeechSDK.OutputFormat.Detailed;
              }

              /*            // Defines the language(s) that speech should be translated to.
                          // Multiple languages can be specified for text translation and will be returned in a map.
                          if (sdkConfigType === SpeechSDK.SpeechTranslationConfig) {
                              speechConfig.addTargetLanguage('Microsoft Server Speech Text to Speech Voice (en-US, ZiraRUS)');
                          }*/

              const langCodeArr = this.voiceMetaData.voice_type.split('-');
              speechConfig.speechRecognitionLanguage = `${langCodeArr[0]}-${langCodeArr[1]}`;

              this.speechRecognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
              this.speechRecognizer.recognizing = this.onRecognizing;
              this.speechRecognizer.recognized = this.onRecognized;
              log.debug("((_VOICE_)) speech recognizer successfully initialized");
              return Promise.resolve();
          }
          // already initialized
          return Promise.resolve();
      });
    }

    public speakIn(): Promise<string> {
      return this.initSpeakIn().then(() => {
        return new Promise((resolve) => {
          log.debug('INITSPEAKIN', this.speechRecognizer)
          this.speechRecognizer.recognizeOnceAsync(
            (successfulResult: any) => {
              log.debug('INITSPEAKIN SUCCESS')
              this.onRecognizedResult(successfulResult, resolve);
            },
            (err: any) => {
              log.debug('INITSPEAKIN ERR')
              alert(err);
              resolve();
            }
          );
        });
      });
    }

    public subscribeToVoiceEvent(event: VoiceContextEvents, callBack: (e: any) => void): void {
       this.eventListeners[event].push(callBack);
    }

    private dispatchVoiceEvent(eventType: VoiceContextEvents, event: any): void {
      this.eventListeners[eventType].forEach((callback) => callback(event));
    }

    public stop(): void {
        if (this.audioInstance) {
            this.audioInstance.pause();
        }
    }

    private freePlayResources = (objectURL: string) => {
        if (this.audioInstance) {
            this.audioInstance.src = '';
            window.URL.revokeObjectURL(objectURL);
        }
    };
    
    private beep = (): Promise<void> => {
        if (this.audioInstance) {
          this.audioInstance.src = this.soundBeep;
          const beepCompletedPromise = new Promise<void>((resolve) => {
            if (this.audioInstance) {
              this.audioInstance.onended = (): void => {
                log.debug("((_VOICE_)) Init sound played");
                resolve();
              };
            }
          });
          this.audioInstance.play();
          return beepCompletedPromise;
        }
        return Promise.reject("Error initializing audio out");
    }
    
    public speak (text: string): Promise<void>  {
        return new Promise((resolve) => {
          text = stripHTML(text);
          text = stripEmojis(text);

          this.synthesizer.speakTextAsync(
            text,
            (result: any) => {
              if (result) {
                log.info("end synthesizer callback", result);

                const audioBlob = new Blob([result.audioData], {
                  type: "audio/mp3",
                });
                log.info(audioBlob);

                if (this.audioInstance) {
                  const objectURL = window.URL.createObjectURL(audioBlob);
                  this.audioInstance.src = objectURL;
                  this.audioInstance.onended = (e: any) => {
                    log.debug("((_VOICE_)) audio instance: onEnded");
                    this.freePlayResources(objectURL);
                    this.dispatchVoiceEvent(
                      VoiceContextEvents.PLAYBACK_STOPPED,
                      e
                    );
                    resolve();
                  };
                  this.audioInstance.onplay = (e: any): void => {
                    log.debug("((_VOICE_)) audio instance: onPlay");
                    this.dispatchVoiceEvent(
                      VoiceContextEvents.PLAYBACK_STARTED,
                      e
                    );
                  };
                  this.audioInstance.play();

                  /*this.audioInstance.ontimeupdate = () => {
                                if (this.audioInstance)
                                    log.debug("((_VOICE_)) playing", this.audioInstance.currentTime * 1000);
                            }*/
                  this.audioInstance.onpause = (e: any) => {
                    log.debug("((_VOICE_)) onPause");
                    this.dispatchVoiceEvent(
                      VoiceContextEvents.PLAYBACK_STOPPED,
                      e
                    );
                    this.freePlayResources(objectURL);
                    resolve();
                  };
                } else {
                  resolve();
                }
              } else {
                resolve();
              }
            },
            (error: any) => {
              log.info(error);
              // synthesizer.close();
              resolve();
            } /*, os*/
          );
        });
    }
}

export const VoiceContext = createContext<VoiceContextImpl>(new VoiceContextImpl({}, '', ''));
